import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fanhui",
  "use": "icon-fanhui-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fanhui\"><defs><style></style></defs><path d=\"M682.667 264.533H256v-93.866l-213.333 128 213.333 128V332.8h426.667c128 0 221.866 85.333 221.866 221.867s-93.866 221.866-221.866 221.866h-256c-17.067 0-34.134 17.067-34.134 34.134S409.6 844.8 426.667 844.8h256C844.8 844.8 972.8 729.6 972.8 554.667s-128-290.134-290.133-290.134z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol